import { FormModal, RadioButton, Text } from '@shootsta/common-react';
import moment from 'moment';
import cx from 'classnames';
import { ViewInvoicesModalProps } from '../types';

import '../styles/_view-invoices-modal.scss';
import { useState } from 'react';

function ViewInvoicesModal({
  visible,
  readableId,
  projectName,
  completedAt,
  onClose,
  invoices = []
}: ViewInvoicesModalProps) {
  const [selectedInvoice, setSelectedInvoice] = useState<string | null>(null);

  const downloadInvoice = (invoiceUrl: string) => {
    if (!invoiceUrl) return;
    window.open(invoiceUrl, '_blank', 'noopener,noreferrer');
    onClose();
  };

  const handleOpenInvoices = () => {
    // Early return if no invoices or multi-invoice case with no selection
    if (!invoices.length || !selectedInvoice) {
      return;
    }

    downloadInvoice(selectedInvoice || '');
  };

  const selectInvoiceToDownload = (invoiceUrl: string) => {
    return () => {
      setSelectedInvoice(invoiceUrl);
    };
  };

  const renderInvoices = () => {
    return invoices.map(({ invoiceId, invoiceUrl, createdAt, refundedAt }) => {
      return (
        <div className="view-invoices-modal__invoice-list--invoice-item">
          <div>
            <RadioButton
              key={`rb-${invoiceId}`}
              value={invoiceUrl}
              selected={invoiceUrl === selectedInvoice}
              onChange={selectInvoiceToDownload(invoiceUrl)}
            />
          </div>
          <div className="view-invoices-modal__invoice-list--invoice-item--mid">
            <Text className="view-invoices-modal__invoice-list--invoice-item--invoice-name">
              {invoiceId.toUpperCase()}
            </Text>
            <Text
              placeholder
            >{`Paid on ${moment(createdAt).format('ll')}`}</Text>
            {refundedAt && (
              <Text
                placeholder
              >{`Refunded on ${moment(refundedAt).format('ll')}`}</Text>
            )}
          </div>
          <div
            className={cx(
              'view-invoices-modal__badge',
              { 'view-invoices-modal__badge--refunded': Boolean(refundedAt) },
              { 'view-invoices-modal__badge--paid': !refundedAt }
            )}
          >
            {refundedAt ? 'Refunded' : 'Paid'}
          </div>
        </div>
      );
    });
  };

  return (
    <div className="view-invoices-modal-wrapper">
      <FormModal
        key="view-invoices-modal"
        visible={visible}
        onSave={handleOpenInvoices}
        onClose={onClose}
        title="Project Invoice Details"
        saveText="View Invoice"
        saveDisabled={selectedInvoice === null}
      >
        <div className="view-invoices-modal">
        <div className="view-invoices-modal__video-info">
          <div className="view-invoices-modal__video-info--content">
            <div>
              <Text heading5>{`[${readableId}] ${projectName}`}</Text>
            </div>
            <div>
              <Text
                body
              >{`Completed ${moment(completedAt).format('ll')}`}</Text>
            </div>
          </div>
        </div>

        <div className="view-invoices-modal__invoices-section">
          <Text label>{`${invoices.length} related invoices`}</Text>
          <div className="view-invoices-modal__invoice-list">
            {renderInvoices()}
          </div>
        </div>
        </div>
      </FormModal>
    </div>
  );
}

export default ViewInvoicesModal;
